import { Injectable } from "@angular/core";
import {
  IHttpErrorPayload,
  HttpRequestPayload,
  IHttpSuccessPayload,
} from "@core/models";
import { HttpProviderService } from "@core/service";
import { catchError, map, Observable, of, throwError } from "rxjs";
import { PreLoginService } from "src/app/pre-login/pre-login.service";
import { IDdrequest, IRequestDDPayload, IRequestDDResponseModel } from "../models/request-dd.model";

@Injectable()
export class RequestDdService {
  constructor(private _httpProviders: HttpProviderService,
    private _preLoginService: PreLoginService) {}

  createRequestDd(payload: IRequestDDPayload) {
    const httpRequestPayload: HttpRequestPayload = {
      method: "POST",
      resource: "/ddrequest",
      body: payload,
    };
    return this._httpProviders.invokeApi(httpRequestPayload).pipe(
      map(
        (response: IHttpSuccessPayload<any>) => {
          const requestDDResponse : IRequestDDResponseModel = {
            httpStatus : response.status,
            inventoryNo : response.body.ddrequest.inventoryNumber,
            refNo: response.body.ddrequest.refNo,
          }
          if (response.status == 201) {
            this._preLoginService.setUserTwoFactor({ email: response.body.ddrequest.twoFactor.email, mobile: response.body.ddrequest.twoFactor.mobile });
          }
          return requestDDResponse
        },
        catchError((err: IHttpErrorPayload) => {
          return of(err);
        })
      )
    );
  }

  fetchDdDetails(requestReference): Observable<IDdrequest> {
    const httpRequest : HttpRequestPayload = {
      resource : `/ddrequest/${requestReference}`,
      method : "GET"
    }
    return this._httpProviders.invokeApi(httpRequest).pipe(map((response : IHttpSuccessPayload<any>) => {
      const requestDdResponse : IDdrequest = response.body.ddrequest
      return requestDdResponse
    },
    catchError((err : IHttpErrorPayload) => { 
      return throwError(err)
    })));
  }
}
